<template>
  <div class="kpi_table--column">
    <app-loading-section :loading="isLoading">
      <div class="kpi_table--column--heading">
        <p>Today</p>
      </div>

      <template v-for="(row, key) in kpiRowInfo">
        <stats-kpi-cell-data
          v-if="doesUserHaveAccess(row.permissionCheck)"
          :key="key"
          :label="row.label"
          :column-data="columnData"
          :amount="columnAmounts[key]"
          :goal="goals[key]"
          :records-endpoint="row.recordsEndpoint"
        />
      </template>
    </app-loading-section>
  </div>
</template>

<script>
import StatsKpiCellData from "./StatsKpiCellData";
import api from "../../../api";

export default {
  name: "StatsKpiColumnToday",
  components: {StatsKpiCellData},
  data() {
    return {
      isLoading: true,
      columnAmounts: []
    }
  },
  created() {
    this.getColumnAmounts();
  },
 computed: {
    authUser() {
      return this.$store.getters.authUser;
    },
   activeTab() {
     return this.$store.state["statsKpi/activeTab"]
   },
    kpiRowInfo() {
      return this.$store.getters["statsKpi/kpiRowInfo"]
    },
    columnData() {
      return this.$store.getters["statsKpi/todayColumn"]
    },
    goals() {
      return this.$store.getters["statsKpi/goals"]
    },
    campaignsFilter() {
      return this.$store.state.statsKpi.filters.campaigns;
    },
   usersFilter() {
     return this.$store.state.statsKpi.filters.users;
   },
  },
  methods: {
    doesUserHaveAccess(rowPermissionCheck) {
      // If rowPermissionCheck is null then show row
      if (!rowPermissionCheck) return true;
      // If owner show all row
      if (this.authUser.is_owner) return true;
      // check if user has rowPermissionCheck
      return this.authUser[rowPermissionCheck];
    },
    getColumnAmounts() {
      this.isLoading = true

      const data = {
        start_at: this.columnData.startAt,
        end_at: this.columnData.endAt,
        campaigns: this.campaignsFilter,
        users: this.usersFilter
      };

      const stats = Object.keys(this.kpiRowInfo);

      if (this.activeTab === 'Comms') {
        Promise.all([
          api.stats.getKPIStats([
            'totalMissedCalls',
            'totalOutboundCalls',
            'totalOutboundTexts',
            'totalMissedCalls',
            'totalOutboundCalls',
            'totalOutboundTexts',
          ], data),
          api.stats.getKPIStats([
            'totalCalls',
            'totalTexts',
            'totalAnsweredCalls',
            'totalInboundCalls',
            'totalInboundTexts',
          ], data)
        ]).then(([firstHalf, secondHalf]) => {
          this.isLoading = false
          return {
            ...firstHalf,
            ...secondHalf
          };
        })
      }

        return api.stats.getKPIStats(stats, data).then(response => {
        this.isLoading = false
        this.columnAmounts = response.data
      });
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.kpi_table--column {
  position: relative;
  flex: 0 0 $kpiColumnSkinny;

  &--cell {
    text-align: center;
    background-color: $grey-50;
  }
}
</style>
